// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  altBusIdType: (
    <FormattedMessage
      id="Global.AltBusIdType"
      defaultMessage="Alt Business Identifier Type:"
    />
  ),
  brandRelationship: (
    <FormattedMessage
      id="Global.BrandRelationship"
      defaultMessage="Brand Relationship:"
    />
  ),
  vertical: (
    <FormattedMessage id="Global.Vertical" defaultMessage="Vertical:" />
  ),
  entityType: (
    <FormattedMessage id="Global.entityType" defaultMessage="Entity Type:" />
  ),
  stockExchange: (
    <FormattedMessage
      id="Global.StockExchange"
      defaultMessage="Stock Exchange:"
    />
  ),
  companyDetails: (
    <FormattedMessage
      id="Global.CompanyDetails"
      defaultMessage="Company Details"
    />
  ),
  mock: <FormattedMessage id="Global.Mock" defaultMessage="Mock:" />,
  brandRelationshipTitle: (
    <FormattedMessage
      id="Global.BrandRelationshipTitle"
      defaultMessage="Brand Relationship"
    />
  ),
  contactDetails: (
    <FormattedMessage
      id="Global.ContactDetails"
      defaultMessage="Contact Details"
    />
  ),
  campaigns: (
    <FormattedMessage id="Global.Campaigns" defaultMessage="Campaigns" />
  ),
  campaignTableCode: (
    <FormattedMessage
      id="Global.CampaignTableCode"
      defaultMessage="Campaign Code"
    />
  ),
  campaignTableName: (
    <FormattedMessage
      id="Global.CampaignTableName"
      defaultMessage="Campaign Name"
    />
  ),
  campaignTableStatus: (
    <FormattedMessage
      id="Global.CampaignTableStatus"
      defaultMessage="Campaign Status"
    />
  ),
  campaignTableCustomer: (
    <FormattedMessage
      id="Global.CampaignTableCustomer"
      defaultMessage="Customer Name"
    />
  ),
  cancel: <FormattedMessage id="Global.Cancel" defaultMessage="Cancel" />,
  vettingReportTitle: (
    <FormattedMessage
      id="Global.VettingReportTitle"
      defaultMessage="External Vetting Report"
    />
  ),
  requestButton: (
    <FormattedMessage id="Global.RequestButton" defaultMessage="Request" />
  ),
  appealButton: (
    <FormattedMessage id="Global.AppealButton" defaultMessage="Appeal" />
  ),
  brandFeedbackTitle: (
    <FormattedMessage
      id="Global.BrandFeedbackTitle"
      defaultMessage="Brand Feedback"
    />
  ),
  usecaseMatrix: (
    <FormattedMessage
      id="Global.UsecaseMatrix"
      defaultMessage="Usecase Matrix"
    />
  ),
  usecase: <FormattedMessage id="Global.Usecase" defaultMessage="Usecase" />,
};
export default FormattedMessages;
